import _toConsumableArray from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import { computed, reactive, ref } from "vue";
import { getPostArticleList } from "../../api/article";
import { defaultThumbnail } from "../../utils/thumbnail";
import { mapState } from "../../store/map";
export default {
  name: "TagDetails",
  setup: function setup(props) {
    var pageSize = 10;
    var postArticles = reactive([]);
    var articleCount = ref(0);

    var _mapState = mapState("tagAbout"),
        tagCounts = _mapState.tagCounts;

    var tagName = computed(function () {
      var map = Object.fromEntries(tagCounts.value.map(function (i) {
        return [i.id, i.name];
      }));
      return map[props.id];
    });
    onCurrentPageChanged(1);

    function onCurrentPageChanged(pageNum) {
      getPostArticleList(pageNum, pageSize, null, props.id).then(function (data) {
        articleCount.value = parseInt(data.total);
        data.rows.forEach(function (article) {
          article.createTime = article.createTime.split(" ")[0];
          article.thumbnail = article.thumbnail || defaultThumbnail;
        });
        postArticles.splice.apply(postArticles, [0, postArticles.length].concat(_toConsumableArray(data.rows)));
      });
    }

    window.scrollTo({
      top: 0
    });
    return {
      tagName: tagName,
      postArticles: postArticles,
      articleCount: articleCount,
      pageSize: pageSize,
      onCurrentPageChanged: onCurrentPageChanged
    };
  },
  props: ["id", "name"]
};